exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ErrorComponent{background:#fff!important}#ErrorComponent .close{align-self:start}#ErrorComponent .v-expansion-panel{background:transparent!important;color:red!important}.v-alert--prominent .v-alert__icon:after{background:none!important}", ""]);

// exports
